import React from "react";
import  Bio  from "./component/home/home";

function App() {
  return (
    <div>
      <Bio/>
    </div>
  );
}

export default App;